import { createSelector } from 'reselect';

// Base selector for transcription reducer
const getTranscriptionReducer = (state) => state.transcriptionreducer;

// Memoized selector for active transcriptions
// Only recomputes when transcriptionreducer actually changes
export const selectActiveTranscriptions = createSelector(
    [getTranscriptionReducer],
    (transcriptions) => {
        if (!Array.isArray(transcriptions)) {
            return [];
        }
        
        // Filter active transcriptions with conversation data
        return transcriptions.filter(item => 
            item && item.peerConversation && item.peerConversation.trim().length > 0
        );
    }
);

// Memoized selector for transcription by peer ID
export const selectTranscriptionByPeerId = createSelector(
    [getTranscriptionReducer, (state, peerId) => peerId],
    (transcriptions, peerId) => {
        if (!Array.isArray(transcriptions) || !peerId) {
            return null;
        }
        
        return transcriptions.find(item => item?.peerId === peerId) || null;
    }
);

// Memoized selector for latest transcription
export const selectLatestTranscription = createSelector(
    [selectActiveTranscriptions],
    (activeTranscriptions) => {
        if (activeTranscriptions.length === 0) {
            return null;
        }
        
        // Return the most recent transcription (first in array due to unshift)
        return activeTranscriptions[0];
    }
);

// Memoized selector for transcription count
export const selectTranscriptionCount = createSelector(
    [selectActiveTranscriptions],
    (activeTranscriptions) => activeTranscriptions.length
);

// Memoized selector for has any transcriptions
export const selectHasTranscriptions = createSelector(
    [selectTranscriptionCount],
    (count) => count > 0
);

// Optimized selector for component-specific data
export const selectTranscriptionComponentData = createSelector(
    [selectActiveTranscriptions, selectTranscriptionCount],
    (transcriptions, count) => ({
        transcriptions,
        count,
        hasData: count > 0,
        isEmpty: count === 0
    })
); 